import { AccordionIcon, InputPercent } from "../../../components/common"
import { OPERATION_MODE } from '@laramie/ui';
const DescuentosAplicables = ({ toggle, open, formValues, handleInputProxy, params }) => {
    return <>
        <div className='accordion-header m-top-20'>
            <div className='row'>
                <div className="col-12" onClick={toggle}>
                    <div className='accordion-header-title'>
                        <AccordionIcon open={open} />
                        <h3 className={open ? 'active' : ''}>Descuentos aplicables</h3>
                    </div>
                </div>
            </div>
        </div>
        {open && (
            <div className='accordion-body'>
                <div className="row form-basic">
                    <div className="col-12 col-md-2">
                        <label htmlFor="porcentajeQuitaRecargos" className="form-label">Quita de recargos</label>
                        <InputPercent
                            name="porcentajeQuitaRecargos"
                            placeholder=""
                            className="form-control"
                            value={formValues.porcentajeQuitaRecargos}
                            onChange={handleInputProxy}
                            disabled={params.mode === OPERATION_MODE.VIEW}
                        />
                    </div>
                    <div className="col-12 col-md-3">
                        <label htmlFor="porcentajeQuitaMultaInfracciones" className="form-label">Quita de multas e infracciones</label>
                        <InputPercent
                            name="porcentajeQuitaMultaInfracciones"
                            placeholder=""
                            className="form-control"
                            value={formValues.porcentajeQuitaMultaInfracciones}
                            onChange={handleInputProxy}
                            disabled={params.mode === OPERATION_MODE.VIEW}
                        />
                    </div>

                    <div className="col-12 col-md-2">
                        <label htmlFor="porcentajeQuitaHonorarios" className="form-label">Quita de causídicos y honorarios</label>
                        <InputPercent
                            name="porcentajeQuitaHonorarios"
                            placeholder=""
                            className="form-control"
                            value={formValues.porcentajeQuitaHonorarios}
                            onChange={handleInputProxy}
                            disabled={params.mode === OPERATION_MODE.VIEW}
                        />
                    </div>
                    <div className="col-12 col-md-2">
                        <label htmlFor="porcentajeQuitaAportes" className="form-label">Quita de aportes</label>
                        <InputPercent
                            name="porcentajeQuitaAportes"
                            placeholder=""
                            className="form-control"
                            value={formValues.porcentajeQuitaAportes}
                            onChange={handleInputProxy}
                            disabled={params.mode === OPERATION_MODE.VIEW}
                        />
                    </div>
                </div>
            </div>
        )}
    </>
}

export default DescuentosAplicables
